import { Injectable } from '@angular/core';
import { SchuleDTO } from '../../../models/schule/SchuleDTO';
import { SchoolType } from '../../../models/schule/SchoolType';

@Injectable({
  providedIn: 'root'
})
export class SchoolDataHelperService {

  constructor() { }

  /**
   * Generische Methode um eine interne ID (number) anhand der UUID (string) zu finden.
   * @param list Die Liste der Objekte (Schulen, Schuljahre, etc.)
   * @param uuidPropName Der Name des UUID-Properties im Objekt (z.B. 'schuleId', 'schuljahrId')
   * @param uuid Die gesuchte UUID
   */
  findIdByUuid<T extends { id: number }>(list: T[], uuidPropName: keyof T, uuid: string): number | null {
    if (!list) return null;
    const item = list.find(element => element[uuidPropName] === uuid);
    return item ? item.id : null;
  }

  /**
   * Generische Methode um eine UUID (string) anhand der internen ID (number) zu finden.
   * @param list Die Liste der Objekte
   * @param uuidPropName Der Name des UUID-Properties im Objekt
   * @param id Die gesuchte interne ID
   */
  findUuidById<T extends { id: number }>(list: T[], uuidPropName: keyof T, id: number): string | null {
    if (!list) return null;
    // Expliziter Cast auf any, da TypeScript dynamischen Zugriff auf generische Keys schwierig findet
    // oder 'uuidPropName' muss string sein, aber wir wollen Typsicherheit.
    // Der Rückgabewert muss string sein.
    const item = list.find(element => element.id === id);
    return item ? (item[uuidPropName] as unknown as string) : null;
  }

  isBerufskolleg(schoolList: SchuleDTO[], schoolId: number): boolean {
    if (!schoolId || !schoolList) {
      return false;
    }
    const school = schoolList.find(s => s.id === schoolId);
    return school?.schoolType === SchoolType.VOCATIONAL;
  }
}

